<div class="dl-pj">
  <button  mat-raised-button color="primary"
          (click)="downloadPieceJointe()" matTooltip="{{tooltip}}"
          [disabled]="!file?.id">
    <mat-icon>file_download</mat-icon>
    Edition du {{type}}
  </button>
</div>

